/* GharGlow theme JS */
(function(){
  'use strict';
  /* Header scroll */
  var header = document.querySelector('.site-header');
  function onScroll(){ if(header) header.classList.toggle('scrolled', window.scrollY > 24); }
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

  /* Reveal on scroll */
  var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); }, {threshold:.12});
  document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });

  /* Drawers */
  var veil = document.getElementById('veil');
  function openDrawer(sel){ var d=document.querySelector(sel); if(!d) return; d.classList.add('open'); if(veil) veil.classList.add('show'); document.body.style.overflow='hidden'; }
  function closeDrawers(){ document.querySelectorAll('.cart-drawer.open,.mobile-nav.open').forEach(function(d){d.classList.remove('open')}); if(veil) veil.classList.remove('show'); document.body.style.overflow=''; }
  if(veil) veil.addEventListener('click', closeDrawers);
  document.querySelectorAll('[data-open-cart]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openDrawer('.cart-drawer'); }); });
  document.querySelectorAll('[data-close-drawer]').forEach(function(b){ b.addEventListener('click', closeDrawers); });
  document.querySelectorAll('[data-open-menu]').forEach(function(b){ b.addEventListener('click', function(){ openDrawer('.mobile-nav'); }); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeDrawers(); if(window.GharGlowCloseQV) window.GharGlowCloseQV(); } });

  /* Money format */
  function money(cents){ return '₹' + (cents/100).toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2}); }

  /* Cart */
  function refreshCartUI(cart){
    document.querySelectorAll('.cart-count').forEach(function(el){ el.textContent = cart.item_count; el.style.display = cart.item_count ? 'grid' : 'none'; });
    var box = document.getElementById('cart-items');
    if(!box) return;
    if(!cart.items.length){
      box.innerHTML = '<div class="cart-empty"><svg viewBox="0 0 24 24"><path d="M6 8h15l-1.5 9h-12z"/><path d="M6 8l-1-4H2"/><circle cx="9" cy="20" r="1.5"/><circle cx="17" cy="20" r="1.5"/></svg><p>Your bag is empty.<br>Smart light for every dark corner.</p><a class="btn btn-dark" href="/products/motion-sensor-wardrobe-light-stick-on-led-puck-pack-of-1">Continue shopping</a></div>';
    } else {
      box.innerHTML = cart.items.map(function(it){
        var im = it.image ? '<img src="'+it.image+'" alt="'+it.title.replace(/"/g,'')+'">' : '<div class="cl-noimg"></div>';
        return '<div class="cart-line" data-key="'+it.key+'">'
          + im
          + '<div><h4>'+it.product_title+'</h4>'
          + (it.variant_title ? '<div class="cl-price">'+it.variant_title+'</div>' : '')
          + '<div class="cl-price">'+money(it.final_price)+'</div>'
          + '<div class="cl-qty"><button data-dec aria-label="Decrease">−</button><span>'+it.quantity+'</span><button data-inc aria-label="Increase">+</button></div>'
          + '<button class="cl-remove" data-remove>Remove</button></div>'
          + '<div><b>'+money(it.final_line_price)+'</b></div></div>';
      }).join('');
    }
    var st = document.getElementById('cart-subtotal');
    if(st) st.textContent = money(cart.total_price);
    var co = document.getElementById('cart-checkout');
    if(co) co.style.display = cart.items.length ? '' : 'none';
    bindLineButtons();
  }
  function bindLineButtons(){
    document.querySelectorAll('#cart-items [data-inc]').forEach(function(b){ b.onclick=function(){ changeQty(b.closest('.cart-line').dataset.key, 1); }; });
    document.querySelectorAll('#cart-items [data-dec]').forEach(function(b){ b.onclick=function(){ changeQty(b.closest('.cart-line').dataset.key, -1); }; });
    document.querySelectorAll('#cart-items [data-remove]').forEach(function(b){ b.onclick=function(){ changeQty(b.closest('.cart-line').dataset.key, 0, true); }; });
  }
  function getCart(){ fetch('/cart.js').then(function(r){return r.json()}).then(refreshCartUI); }
  function changeQty(key, delta, remove){
    var line = document.querySelector('.cart-line[data-key="'+key+'"]');
    var qty = line ? parseInt(line.querySelector('.cl-qty span').textContent,10) : 1;
    var q = remove ? 0 : qty + delta;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:q})})
      .then(function(r){return r.json()}).then(getCart);
  }
  window.GharGlowAdd = function(id, qty){
    qty = qty || 1;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:qty})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(){ getCart(); openDrawer('.cart-drawer'); })
      .catch(function(){ alert('Could not add to bag. Please try again.'); });
  };
  document.querySelectorAll('[data-quick-add]').forEach(function(b){
    b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); window.GharGlowAdd(b.dataset.quickAdd); });
  });

  /* PDP */
  var atc = document.getElementById('pdp-atc');
  if(atc){
    atc.addEventListener('click', function(){
      var id = document.getElementById('pdp-variant').value;
      var q = parseInt((document.getElementById('pdp-qty')||{value:1}).value,10) || 1;
      atc.disabled = true; atc.textContent = 'Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:q})})
        .then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(){ getCart(); openDrawer('.cart-drawer'); })
        .catch(function(){ alert('Could not add to bag. Please try again.'); })
        .finally(function(){ atc.disabled = false; atc.textContent = atc.dataset.label; });
    });
    var qminus=document.getElementById('q-minus'), qplus=document.getElementById('q-plus'), qinput=document.getElementById('pdp-qty');
    if(qminus) qminus.onclick=function(){ var n=parseInt(qinput.value,10); qinput.value=isNaN(n)?1:Math.max(1,n-1); };
    if(qplus) qplus.onclick=function(){ var n=parseInt(qinput.value,10); qinput.value=isNaN(n)?1:n+1; };
    if(qinput) qinput.addEventListener('change', function(){ var n=parseInt(qinput.value,10); qinput.value=isNaN(n)?1:Math.max(1,n); });
    var thumbs=document.querySelectorAll('.pdp-thumbs button'), main=document.getElementById('pdp-main-img');
    thumbs.forEach(function(t){ t.addEventListener('click',function(){ thumbs.forEach(function(x){x.classList.remove('active')}); t.classList.add('active'); if(main) main.src=t.dataset.full; }); });
  }

  /* Accordions */
  document.querySelectorAll('.acc-head').forEach(function(h){
    h.addEventListener('click', function(){
      var item=h.parentElement, body=item.querySelector('.acc-body'), open=item.classList.contains('open');
      item.parentElement.querySelectorAll('.acc-item').forEach(function(x){ x.classList.remove('open'); x.querySelector('.acc-body').style.maxHeight=null; x.querySelector('.acc-head').setAttribute('aria-expanded','false'); });
      h.setAttribute('aria-expanded', String(!open));
      if(!open){ item.classList.add('open'); body.style.maxHeight=body.scrollHeight+'px'; }
    });
  });

  /* Newsletter */
  document.querySelectorAll('.news-form').forEach(function(f){
    f.addEventListener('submit', function(e){
      e.preventDefault();
      var email=f.querySelector('input[type=email]').value;
      fetch('/contact#newsletter',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},body:'form_type=customer&contact[email]='+encodeURIComponent(email)+'&contact[tags]=newsletter'})
        .then(function(){ f.innerHTML='<p style="padding:14px 22px">'+f.dataset.success+'</p>'; })
        .catch(function(){ f.innerHTML='<p style="padding:14px 22px">Something went wrong. Please try again.</p>'; });
    });
  });

  getCart();
})();

/* GharGlow v1.0 — conversion upgrades */
(function(){
  'use strict';
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Rotating announcement (respects reduced motion) */
  var ann = document.querySelector('.announce');
  if(ann){
    var msgs = [];
    try { msgs = JSON.parse(ann.dataset.msgs || '[]'); } catch(e){}
    msgs = msgs.filter(function(m){ return m && (''+m).trim().length; });
    if(msgs.length > 1 && !reducedMotion){
      var cur = 0;
      ann.innerHTML = msgs.map(function(m,i){ return '<span class="ann-msg'+(i===0?' on':'')+'">'+m+'</span>'; }).join('');
      var spans = ann.querySelectorAll('.ann-msg');
      setInterval(function(){ spans[cur].classList.remove('on'); cur = (cur+1)%spans.length; spans[cur].classList.add('on'); }, 4200);
    }
  }
  /* Sticky ATC */
  var sticky = document.getElementById('sticky-atc'), atc = document.getElementById('pdp-atc');
  var toTop = document.getElementById('to-top');
  if(sticky && atc){
    var saBtn = sticky.querySelector('[data-sa-add]');
    function onScroll2(){
      var r = atc.getBoundingClientRect();
      var show = r.bottom < 0;
      sticky.classList.toggle('show', show);
      if(toTop) toTop.classList.toggle('above-sticky', show);
    }
    window.addEventListener('scroll', onScroll2, {passive:true});
    if(saBtn) saBtn.addEventListener('click', function(){ atc.click(); });
  }
  /* Pincode checker (form submit so mobile Go works) */
  var pcForm = document.getElementById('pc-form');
  if(pcForm){
    pcForm.addEventListener('submit', function(e){
      e.preventDefault();
      var input = document.getElementById('pc-input'), msg = document.getElementById('pc-msg');
      var pin = (input.value||'').replace(/\D/g,'').slice(0,6);
      input.value = pin;
      if(/^\d{6}$/.test(pin)){
        msg.classList.remove('err');
        msg.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg><span>Delivering to <b>'+pin+'</b> in 3–5 business days · COD available</span>';
      } else {
        msg.classList.add('err');
        msg.innerHTML = '<span>Please enter a valid 6-digit pincode.</span>';
      }
      msg.classList.add('show');
    });
  }
  /* Quick view */
  var veil = document.getElementById('qv-veil'), qv = document.getElementById('quick-view');
  function closeQV(){ if(veil) veil.classList.remove('show'); if(qv) qv.classList.remove('show'); document.body.style.overflow=''; }
  window.GharGlowCloseQV = closeQV;
  if(veil) veil.addEventListener('click', closeQV);
  document.querySelectorAll('[data-quick-view]').forEach(function(b){
    b.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      var handle = b.dataset.quickView;
      fetch('/products/'+handle+'.js').then(function(r){ return r.json(); }).then(function(p){
        var v = p.variants.find(function(x){return x.available});
        var img = (p.images && p.images[0]) || '';
        var title = (p.title||'').replace(/</g,'&lt;');
        var priceHtml = v ? '<div class="price">₹'+(v.price/100).toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2})+'</div>' : '';
        var body = '<h3>'+title+'</h3>' + priceHtml
          + '<div class="qv-desc">'+(p.description||'').replace(/<[^>]*>/g,'').slice(0,220)+'</div>'
          + '<div class="qv-atc-row">';
        if(v){
          body += '<button class="btn btn-gold" style="flex:1" data-qv-add="'+v.id+'">Add to Bag</button>';
        } else {
          body += '<button class="btn btn-gold" style="flex:1" disabled>Sold Out</button>';
        }
        body += '<a class="btn btn-outline" href="/products/'+p.handle+'">Details</a></div>';
        qv.querySelector('.qv-media').innerHTML = img ? '<img src="'+img+'" alt="'+title+'">' : '';
        qv.querySelector('.qv-body').innerHTML = body;
        qv.setAttribute('aria-label', title);
        var addBtn = qv.querySelector('[data-qv-add]');
        if(addBtn) addBtn.addEventListener('click', function(){
          window.GharGlowAdd(parseInt(this.dataset.qvAdd,10)); closeQV();
        });
        veil.classList.add('show'); qv.classList.add('show'); document.body.style.overflow='hidden';
      }).catch(function(){ window.location.href = '/products/'+handle; });
    });
  });
  var qvClose = document.getElementById('qv-close');
  if(qvClose) qvClose.addEventListener('click', closeQV);
  /* Back to top */
  if(toTop){
    window.addEventListener('scroll', function(){ toTop.classList.toggle('show', window.scrollY > 700); }, {passive:true});
    toTop.addEventListener('click', function(){ window.scrollTo({top:0, behavior:'smooth'}); });
  }
  /* PDP variant option pills */
  var optBlock = document.getElementById('opt-block');
  if(optBlock){
    var variantInput = document.getElementById('pdp-variant');
    optBlock.querySelectorAll('.opt-pills').forEach(function(row){
      row.addEventListener('click', function(e){
        var pill = e.target.closest('.opt-pill'); if(!pill) return;
        row.querySelectorAll('.opt-pill').forEach(function(x){ x.classList.remove('on'); });
        pill.classList.add('on');
        var chosen = [];
        optBlock.querySelectorAll('.opt-pills').forEach(function(r){
          var on = r.querySelector('.opt-pill.on'); chosen.push(on ? on.dataset.val : null);
        });
        fetch('/products/'+optBlock.dataset.handle+'.js').then(function(r){ return r.json(); }).then(function(p){
          var match = p.variants.find(function(vr){
            return vr.options.every(function(o,i){ return chosen[i] === null || o === chosen[i]; });
          });
          if(match && variantInput){ variantInput.value = match.id; }
        });
      });
    });
  }
})();

/* GharGlow v2.0 — premium layer */
(function(){
  'use strict';
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal v2: observe .reveal, stagger children inside [data-stagger] */
  document.querySelectorAll('[data-stagger]').forEach(function(group){
    var items = group.querySelectorAll(':scope > .reveal');
    if(!items.length) items = group.querySelectorAll('.reveal');
    items.forEach(function(el, i){ el.style.setProperty('--rd', Math.min(i * 90, 720) + 'ms'); });
  });
  if(!reducedMotion && 'IntersectionObserver' in window){
    var io2 = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io2.unobserve(e.target); } });
    }, {threshold:.12, rootMargin:'0px 0px -6% 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){ io2.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  /* Before / after slider — pointer drag + keyboard */
  document.querySelectorAll('.ba').forEach(function(ba){
    var after = ba.querySelector('.ba-after'), handle = ba.querySelector('.ba-handle');
    var pos = 50;
    function setPos(p){
      pos = Math.max(2, Math.min(98, p));
      after.style.clipPath = 'inset(0 0 0 ' + pos + '%)';
      handle.style.left = pos + '%';
      ba.setAttribute('aria-valuenow', Math.round(pos));
    }
    function fromEvent(e){
      var r = ba.getBoundingClientRect();
      setPos(((e.clientX - r.left) / r.width) * 100);
    }
    var dragging = false;
    ba.addEventListener('pointerdown', function(e){ dragging = true; ba.setPointerCapture(e.pointerId); fromEvent(e); });
    ba.addEventListener('pointermove', function(e){ if(dragging) fromEvent(e); });
    ba.addEventListener('pointerup', function(){ dragging = false; });
    ba.addEventListener('pointercancel', function(){ dragging = false; });
    ba.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft'){ setPos(pos - 5); e.preventDefault(); }
      else if(e.key === 'ArrowRight'){ setPos(pos + 5); e.preventDefault(); }
    });
    setPos(50);
  });

  /* Bundle upsell quick add */
  document.querySelectorAll('[data-bundle-add]').forEach(function(b){
    b.addEventListener('click', function(){
      var id = parseInt(b.dataset.bundleAdd, 10);
      b.disabled = true;
      var label = b.textContent;
      b.textContent = 'Adding…';
      if(window.GharGlowAdd){ window.GharGlowAdd(id, 1); }
      b.disabled = false;
      b.textContent = label;
    });
  });
})();

/* GharGlow v2.1 — interactive layer */
(function(){
  'use strict';
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 1023px)').matches || ('ontouchstart' in window && window.innerWidth < 1024);

  /* Hero parallax — rAF throttled, desktop only, no reduced motion */
  var hero = document.querySelector('.hero'), heroContent = document.querySelector('.hero-content');
  if(hero && heroContent && !reducedMotion && !isMobile){
    var ticking = false;
    function parallax(){
      var y = window.scrollY;
      if(y < window.innerHeight * 1.2){
        heroContent.style.transform = 'translateY(' + (y * 0.22) + 'px)';
      }
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if(!ticking){ ticking = true; requestAnimationFrame(parallax); }
    }, {passive:true});
  }

  /* Interactive sensor demo — cursor/finger is the motion */
  document.querySelectorAll('[data-demo]').forEach(function(stage){
    var glow = stage.querySelector('[data-glow]'),
        pill = stage.querySelector('[data-pill]'),
        pillText = stage.querySelector('[data-pill-text]'),
        idleText = stage.dataset.idle || 'No motion · Light OFF',
        activeText = stage.dataset.active || 'Motion detected · Light ON',
        idleTimer = null, raf = null, px = 50, py = 50;
    function paint(){
      raf = null;
      glow.style.setProperty('--gx', px + '%');
      glow.style.setProperty('--gy', py + '%');
    }
    function motionOn(x, y){
      px = x; py = y;
      if(!raf) raf = requestAnimationFrame(paint);
      if(!stage.classList.contains('lit')){
        stage.classList.add('lit');
        if(pillText) pillText.textContent = activeText;
      }
      clearTimeout(idleTimer);
      idleTimer = setTimeout(motionOff, 1400);
    }
    function motionOff(){
      stage.classList.remove('lit');
      if(pillText) pillText.textContent = idleText;
    }
    function pointFromEvent(e){
      var r = stage.getBoundingClientRect();
      var cx = (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;
      var cy = (e.touches && e.touches[0]) ? e.touches[0].clientY : e.clientY;
      motionOn(((cx - r.left) / r.width) * 100, ((cy - r.top) / r.height) * 100);
    }
    stage.addEventListener('pointermove', pointFromEvent, {passive:true});
    stage.addEventListener('pointerdown', pointFromEvent, {passive:true});
    stage.addEventListener('pointerleave', function(){ clearTimeout(idleTimer); motionOff(); });
    /* Keyboard: focus = motion */
    stage.addEventListener('focus', function(){ motionOn(50, 45); });
    stage.addEventListener('blur', function(){ clearTimeout(idleTimer); motionOff(); });
    if(reducedMotion){ motionOn(50, 45); clearTimeout(idleTimer); }
  });

  /* Testimonials carousel */
  document.querySelectorAll('[data-tmn]').forEach(function(tmn){
    var track = tmn.querySelector('[data-tmn-track]'),
        slides = track ? track.children.length : 0,
        dotsBox = tmn.querySelector('[data-tmn-dots]'),
        dots = dotsBox ? Array.prototype.slice.call(dotsBox.children) : [],
        idx = 0, timer = null;
    if(!track || slides < 1) return;
    function go(n){
      idx = (n + slides) % slides;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      dots.forEach(function(d, i){ d.classList.toggle('on', i === idx); });
    }
    function auto(){
      clearInterval(timer);
      if(slides > 1 && !reducedMotion){
        timer = setInterval(function(){ go(idx + 1); }, 6000);
      }
    }
    var prev = tmn.querySelector('[data-tmn-prev]'), next = tmn.querySelector('[data-tmn-next]');
    if(prev) prev.addEventListener('click', function(){ go(idx - 1); auto(); });
    if(next) next.addEventListener('click', function(){ go(idx + 1); auto(); });
    dots.forEach(function(d, i){ d.addEventListener('click', function(){ go(i); auto(); }); });
    /* Swipe */
    var startX = null;
    tmn.addEventListener('pointerdown', function(e){ startX = e.clientX; clearInterval(timer); }, {passive:true});
    tmn.addEventListener('pointerup', function(e){
      if(startX === null) return;
      var dx = e.clientX - startX;
      if(Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      startX = null; auto();
    }, {passive:true});
    tmn.addEventListener('mouseenter', function(){ clearInterval(timer); });
    tmn.addEventListener('mouseleave', auto);
    if(slides === 1){
      if(prev) prev.style.display = 'none';
      if(next) next.style.display = 'none';
      if(dotsBox) dotsBox.style.display = 'none';
    }
    auto();
  });
})();
